import { render, staticRenderFns } from "./div-top.vue?vue&type=template&id=5d880045&scoped=true"
import script from "./div-top.vue?vue&type=script&lang=js"
export * from "./div-top.vue?vue&type=script&lang=js"
import style0 from "./div-top.vue?vue&type=style&index=0&id=5d880045&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d880045",
  null
  
)

export default component.exports